<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <v-container v-else class="Kanit" style="padding-bottom: 80px">
      <div style="text-align: center" class="py-2 mb-3">
        <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
      </div>
      <h2 style="color: #0c4d9d" class="mb-4">อัพโหลดหลักฐานการชำระเงิน</h2>
      <div class="text-center mb-6">
        <ValidationObserver ref="observer" tag="form">
          <ValidationProvider
            name="รูป"
            :rules="{
              required: true,
            }"
            v-slot="{ errors }"
          >
            <UploadSingleFile
              v-model="input.slip"
              :errors="errors"
              :height="120"
              :maxwidth="700"
              :maxheight="700"
              :background="require('../assets/billimg.jpg')"
            ></UploadSingleFile>
          </ValidationProvider>
          <v-row>
            <v-col cols="6" class="pr-0">
              <div>
                <v-menu
                  ref="menu1"
                  v-model="menudate"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="วันที่"
                      rules="required"
                      key="startdate"
                    >
                      <v-text-field
                        outlined
                        dense
                        :error-messages="errors"
                        v-on="on"
                        name="date"
                        placeholder="วันที่"
                        :value="
                          input.date
                            ? moment(input.date)
                                .locale('TH')
                                .format('DD MMMM YYYY')
                            : ''
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    locale="th"
                    v-model="input.date"
                    no-title
                    @input="menudate = false"
                  ></v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col cols="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="เวลา"
                rules="required"
                key="time"
              >
                <v-digital-time-picker
                  name="time"
                  placeholder="เวลา"
                  v-model="input.time"
                  :error-messages="errors"
                  style="border-radius: 12px"
                  dense
                  outlined
                />
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
      <div
        v-if="data && data.dealer_bank_account"
        style="line-height: 19px; padding-left: 10px"
      >
        <div class="banklabel">ชื่อธนาคาร</div>
        <div class="bankinfo">
          {{
            data.dealer_bank_account.bankname
              ? data.dealer_bank_account.bankname
              : "-"
          }}
        </div>
        <div class="banklabel mt-2">ชื่อบัญชีร้านค้า</div>
        <div class="bankinfo">
          {{
            data.dealer_bank_account.bank_account_name
              ? data.dealer_bank_account.bank_account_name
              : "-"
          }}
        </div>
        <div class="banklabel mt-2">เลขที่บัญชี</div>
        <div class="bankinfo">
          {{
            data.dealer_bank_account.bank_account_number
              ? data.dealer_bank_account.bank_account_number
              : "-"
          }}
        </div>
      </div>

      <div v-if="data && data.orderdetail">
        <v-card
          outline
          class="mb-2 pa-1 Kanit"
          outlined
          v-for="item in data.orderdetail.productlist"
          :key="item.id"
        >
          <v-row>
            <v-col cols="5">
              <div v-if="item.image">
                <v-img
                  lazy-src="../assets/whiteimg.jpg"
                  :src="item.image"
                  @error="() => (item.image = null)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
              <div v-else>
                <div
                  style="
                    height: 100px;
                    width: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <v-icon>mdi-block-helper</v-icon>
                </div>
              </div>
            </v-col>
            <v-col class="pl-0" cols="7">
              <div style="font-weight: bold; font-size: 13px">
                {{ item.sales_text_th }}
              </div>
              <div style="padding-right: 13px; font-size: 11px">
                ขนาด: {{ item.size }} สี: {{ item.shade }}
                {{ item.film_type ? `ฟิล์ม: ` + item.film_type : "" }}
              </div>
              <div
                style="padding-right: 13px; font-weight: bold; font-size: 13px"
              >
                จำนวน: {{ item.quantity }}
              </div>
              <div style="font-size: 35px"></div>
              <div v-if="item.price" style="color: red">
                ราคารวม:
                {{ parseFloat(item.quantity) * parseFloat(item.price) }}
              </div>
              <div v-else style="color: red">ราคารวม: 0</div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div
        @click="toapaymentbybanktransfer"
        v-ripple
        class="addcartbtn Kanit myshadow"
      >
        <p v-if="!saveloading">ยืนยัน</p>
        <div v-else>
          <v-progress-circular
            indeterminate
            size="35"
            color="white"
          ></v-progress-circular>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Loading from "@/components/Loading.vue";
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import { VDigitalTimePicker } from "v-digital-time-picker";

export default {
  components: {
    Loading,
    UploadSingleFile,
    VDigitalTimePicker,
  },
  data() {
    return {
      saveloading: false,
      data: "",
      loading: false,
      menudate: false,
      input: { slip: "", date: "", time: "" },
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    moment() {
      return moment;
    },
  },
  mounted() {
    var vm = this;
    vm.getBankInfo();
  },
  methods: {
    async toapaymentbybanktransfer() {
      var isValid = await this.$refs.observer.validate();

      if (isValid && !this.saveloading) {
        this.saveloading = true;
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          dealerid: this.query.dealerid,
          order_number: this.query.order_number,
          banktransfer_image: this.input.slip, // url รูปสลิป
          banktransfer_date: moment(this.input.date).format("YYYY/MM/DD"), // วันที่โอนเงิน YYYY/MM/DD
          banktransfer_time: this.input.time, // เวลาที่โอนเงิน Ex. 18:00
        };
        axios
          .put(
            "https://communitybotbyzwizai.herokuapp.com/toapaymentbybanktransfer",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            } else if (response.data.responsecode == 200) {
              await this.$swal.fire({
                icon: "success",
                text: "สำเร็จ",
                confirmButtonText: "ตกลง",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            }
            this.loading = false;
          });
      }
    },
    getBankInfo() {
      var vm = this;
      this.loading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        dealerid: this.query.dealerid,
        order_number: this.query.order_number,
      };
      axios
        .get(
          "https://communitybotbyzwizai.herokuapp.com/toapaymentbybanktransfer",
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: data,
          }
        )
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            this.data = response.data.data[0];
          } else if (response.data.responsecode == 400) {
            await vm.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            if (this.query.apptype == "line") {
              await this.$liff.closeWindow();
            } else if (this.query.apptype == "facebook") {
              this.$store.dispatch("messengerClose");
            }
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>